import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import Img from "gatsby-image";
import Theme from "../../../../vars/ThemeOptions";
import { Button, H3 } from "../../../common";

const WrapCont = styled(Container)`
  margin: 2rem auto 4rem auto;
  text-align: center;
  p {
    padding: 0 25%;
  }
  .image-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    .gatsby-image-wrapper {
      width: 50%;
    }
  }
  a {
    background: ${Theme.hex("blue")};
    color: ${Theme.hex("white")};
    padding: 0.5rem 2rem;
    margin-top: 1rem;
    display: inline-block;
  }
  @media only screen and (max-width: 991px) {
    p {
      padding: 0 5%;
    }
    .image-wrap {
      .gatsby-image-wrapper {
        width: 90%;
      }
    }
  }
`;

export const TextAboveImageAboveLink = ({ link }) => {
  //console.log("link: ",link)
  const { title, subtext, coverImage, entry } = link;
  const { fluid } = coverImage ? coverImage : null;
  const { slug } = entry;
  return (
    <WrapCont>
      {title && <H3>{title}</H3>}
      {subtext && subtext.subtext && <p>{subtext.subtext}</p>}
      {fluid && (
        <div className="image-wrap">
          <Img fluid={fluid} alt={coverImage.title} />
        </div>
      )}
      {slug && <Button to={"/" + slug}>Learn More</Button>}
    </WrapCont>
  );
};
